module.exports = __webpack_public_path__ + "images/img-1z8QISG.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/offers.jpg
// module id = 2003
// module chunks = 0